// extracted by mini-css-extract-plugin
export var menuItem = "F_tz d_fW d_bw d_bz d_bL d_bb";
export var menuItemSub = "F_tB d_W d_bw d_bL";
export var menuMainLink = "F_tC d_fX d_dx";
export var menuLink = "F_tD d_fX d_dx";
export var Link = "F_sz x_sz x_rV x_sd";